import AssetCategoryInterface from 'model/AssetModel/AssetCategoryInterface';
import { ReduxRootState, RootState } from 'model/Redux';
import { Selector } from 'reselect';

export const assetsCategoriesSelector: Selector<RootState, ReduxRootState<AssetCategoryInterface[]>> = state => state.assetsCategories;